import React from "react";

import { isViewVisible } from "../../../utils/ViewSettings";
import ReportsView from "./components/ReportsView";

type Props = {
  view?: string;
  dispatch: any;
  returnPath: string;
  params: any;
  add: boolean;
};
export const ReportsPage: (props: Props) => React.JSX.Element = (
  props: Props,
): React.JSX.Element => {
  let _view = typeof props.view === "undefined" || props.view === null ? "index" : props.view;
  return (
    <>
      {(_view === "reports" || _view === "index") && (
        <ReportsView
          name={"reports"}
          dispatch={props.dispatch}
          params={props.params}
          returnPath={props.returnPath}
          intAdd={props.add}
        />
      )}
    </>
  );
};
